/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForAwsKubernetesUserManaged extends models.StorageConfigurationForKubernetesUserManaged {
    getFixupPrototypeFunction() { return StorageConfigurationForAwsKubernetesUserManaged.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForAwsKubernetesUserManaged>): StorageConfigurationForAwsKubernetesUserManaged {
        let obj = Object.assign(new StorageConfigurationForAwsKubernetesUserManaged(), model);
        StorageConfigurationForAwsKubernetesUserManaged.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForAwsKubernetesUserManaged>): StorageConfigurationForAwsKubernetesUserManaged {
        if (!model) return null;
        return StorageConfigurationForAwsKubernetesUserManaged.newInstance(<StorageConfigurationForAwsKubernetesUserManaged> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForAwsKubernetesUserManaged) {
        if (!obj) return;

        models.StorageConfigurationForAwsKubernetesUserManaged.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForAwsKubernetesUserManaged): boolean {
        if (models.StorageConfigurationForKubernetesUserManaged.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForAwsKubernetesUserManaged.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Storage Bucket Name
     */
    bucket_name: string;

    /**
     * File Path in the Bucket
     */
    file_path: string;

}
